/*eslint-disable*/ export const messages = {
    'Add "{inputValue}"': ['Agregar "', ["inputValue"], '"'],
    "All items have been removed.": "Se eliminaron todos los elementos.",
    "Clear selection": "Borrar selección",
    "No results found.": "No se encontraron resultados.",
    "Select All": "Seleccionar todo",
    "Selected Items": "Elementos seleccionados",
    "Toggle menu": "Alternar menú",
    "listbox contents": "Contenido del cuadro de lista",
    "{itemAsString} has been removed.": [["itemAsString"], " se ha eliminado."],
    "{itemAsString} has been selected.": [["itemAsString"], " se ha seleccionado."],
    "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.":
        [
            [
                "resultCount",
                "plural",
                { one: ["#", " resultado está disponible"], other: ["#", " resultados están disponibles"] },
            ],
            ", use las flechas hacia arriba y hacia abajo para desplazarse. Presione Entrar para seleccionar.",
        ],
    "{selectedValue} selected": [["selectedValue"], " seleccionado"],
};
